export const getUserId = (): number | undefined => {
  const storedUser = localStorage.getItem('user');
  if (!storedUser) return undefined;
  try {
    return JSON.parse(storedUser)?.id;
  } catch {
    return undefined;
  }
};
